import styled from 'styled-components';

export const CardHeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const CardHeaderTopColumn = styled.div`
  display: flex;
  align-items: center;

  h3 {
    margin-bottom: 0;
  }
`;

export const SelectListItem = styled.li`
  display: flex;
  margin: 5px 0;

  label {
    cursor: pointer;
    padding: 0 5px;
  }
`;
